export default class Helper {
  constructor() {
    this.usedIds = [];
  }

  hasClass(el, className) {
    if (!el) {
      return false;
    }

    if (el.classList) {
      return el.classList.contains(className);
    }

    if (el.className.split(' ').indexOf(className) > 0) {
      return true;
    }

    return false;
  }

  findFreeHTMLId(prefix = 'id') {
    for (let i = 0; i < 10000; i++) {
      if (!document.getElementById(`${prefix}_${i}`) && this.usedIds.indexOf(`${prefix}_${i}`) === -1) {
        this.usedIds.push(`${prefix}_${i}`);
        return `${prefix}_${i}`;
      }
    }
    return false;
  }

  addClass(el, className) {
    if (!el) {
      return;
    }

    if (el.classList) {
      el.classList.add(className);
    } else {
      el.className += ` ${className}`;
    }
  }

  removeClass(el, className) {
    if (!el) {
      return;
    }

    if (el.classList) {
      el.classList.remove(className);
    } else {
      const classes = el.className.split(' ');
      const classIndex = classes.indexOf(className);
      if (classIndex > 0) {
        classes.splice(classIndex, 1);
      }

      el.className = classes.join(' ');
    }
  }

  toggleClass(el, className) {
    if (!el) {
      return;
    }

    if (el.classList) {
      el.classList.toggle(className);
    } else if (this.hasClass(el, className)) {
      this.removeClass(el, className);
    } else {
      this.addClass(el, className);
    }
  }

  updateMaterialInput(elem) {
    if (elem.value && elem.value.length) {
      elem.classList.add('has-value');
    } else {
      elem.classList.remove('has-value');
    }
  }
}
